import { Navigate, Outlet, RouterProvider, createBrowserRouter } from 'react-router-dom';

import { AgentCatalogRoutes, MyAgentsRoutes } from '@web/app/features/agents';
import { CodesKeysRoutes } from '@web/app/features/codes-keys';
import { LogsRoutes } from '@web/app/features/logs';
import { MarketplaceRoutes } from '@web/app/features/marketplace';
import { MyPageRoutes } from '@web/app/features/my-page';
import { PolicyRoutes } from '@web/app/features/policy';
import { PromptsRoutes } from '@web/app/features/prompts';
import { ShowCatalogRoutes } from '@web/app/features/show-catalogs';

import { AuthGuard } from './guards';
import { AuthRoutes } from '../features/auth';
import { CatalogRoutes } from '../features/catalogs';
import { NewHomeRoutes } from '../features/home';
import { TeamRoutes } from '../features/teams';
import { WorkspaceContextRedirect } from '../shared/components';

const ProtectedLayout = () => {
    return (
        <AuthGuard>
            <Outlet />
        </AuthGuard>
    );
};

const router = createBrowserRouter([
    {
        path: '/',
        element: <WorkspaceContextRedirect />,
    },
    {
        path: '/',
        element: <ProtectedLayout />,
        children: [
            // Workspace routes
            { path: '/w', element: <NewHomeRoutes /> },
            { path: '/w/*', element: <NewHomeRoutes /> },

            // Workspace-level routes (not project dependent)
            { path: `/w/:workspaceId/teams/*`, element: <TeamRoutes /> },
            { path: `/w/:workspaceId/my-page/*`, element: <MyPageRoutes /> },
            { path: `/w/:workspaceId/codes-keys/*`, element: <CodesKeysRoutes /> },
            { path: `/w/:workspaceId`, element: <NewHomeRoutes /> },

            // Project-level routes
            { path: `/w/:workspaceId/p/:projectId`, element: <NewHomeRoutes /> },
            { path: `/w/:workspaceId/p/:projectId/catalogs/*`, element: <CatalogRoutes /> },

            // AI routes (project-level)
            { path: `/w/:workspaceId/p/:projectId/my-agents/*`, element: <MyAgentsRoutes /> },
            { path: `/w/:workspaceId/p/:projectId/agent-catalogs/*`, element: <AgentCatalogRoutes /> },
            { path: `/w/:workspaceId/p/:projectId/prompts/*`, element: <PromptsRoutes /> },
            { path: `/w/:workspaceId/p/:projectId/marketplace/*`, element: <MarketplaceRoutes /> },

            // Logs
            { path: `/w/:workspaceId/p/:projectId/logs/*`, element: <LogsRoutes /> },
            { path: `/logs/*`, element: <LogsRoutes /> },

            // Legacy routes (keep for backward compatibility)
            { path: `/catalogs/*`, element: <CatalogRoutes /> },
            { path: '/teams/*', element: <TeamRoutes /> },
            { path: `/my-page/*`, element: <MyPageRoutes /> },
            { path: `/codes-keys/*`, element: <CodesKeysRoutes /> },
            { path: `/my-agents/*`, element: <MyAgentsRoutes /> },
            { path: `/agent-catalogs/*`, element: <AgentCatalogRoutes /> },
            { path: `/prompts/*`, element: <PromptsRoutes /> },
            { path: `/marketplace/*`, element: <MarketplaceRoutes /> },

            { path: '*', element: <Navigate to="/w" replace /> },
        ],
    },
    { path: `/auth/*`, element: <AuthRoutes /> },
    { path: `/policy/*`, element: <PolicyRoutes /> },
    { path: `/show-catalogs/*`, element: <ShowCatalogRoutes /> },

    { path: '*', element: <Navigate to="/w" replace /> },
]);

export const Router = () => {
    return <RouterProvider router={router} />;
};
